<template>
  <div class="meta-item-back mt-3">
    <span class="mr-2">{{text}}</span>
     <i :class="['icon', type_arrow]" />
  </div>
</template>

<script>
export default {
  name: 'Navigate',
  props: ['text', 'type_arrow']
}
</script>

<style scoped>
@import "./styles.scss";
</style>